import {
	useBlockProps,
	InspectorControls,
	MediaUpload,
	MediaUploadCheck,
	RichText,
	InnerBlocks,
} from "@wordpress/block-editor";
import { Panel, PanelBody, TextControl } from "@wordpress/components";
import {
	GeneralButton,
	AgendarCitaButton,
} from "../components/generalButton.js";

const Edit = (props) => {
	const blockProps = useBlockProps();
	const homeUrl = "/dr-carlos-gamboa/"; // Reemplaza con la URL correcta

	const { className, attributes, setAttributes } = props;
	const { imageUrlMobile, imageUrl, cgdescription, cgtitle, cgsubtitle } =
		attributes;

	return (
		<>
			<InspectorControls>
				<Panel>
					<PanelBody title="Imagen de fondo">
						<MediaUploadCheck>
							<MediaUpload
								onSelect={(media) => setAttributes({ imageUrl: media.url })}
								allowedTypes={["image"]}
								value={imageUrl}
								render={({ open }) => (
									<button onClick={open} isPrimary>
										Seleccionar Imagen
										{imageUrl}
									</button>
								)}
							/>
						</MediaUploadCheck>
					</PanelBody>
					<PanelBody title="Imagen de fondo Mobile">
						<MediaUploadCheck>
							<MediaUpload
								onSelect={(media) =>
									setAttributes({ imageUrlMobile: media.url })
								}
								allowedTypes={["image"]}
								value={imageUrlMobile}
								render={({ open }) => (
									<button className="bg-gray-500" onClick={open} isPrimary>
										Seleccionar Imagen
										{imageUrlMobile}
									</button>
								)}
							/>
						</MediaUploadCheck>
					</PanelBody>
				</Panel>
			</InspectorControls>
			<div
				{...blockProps}
				className="cg-blocks-wrapper-class relative banner bg-cgBlue"
			>
				<figure className="overflow-hidden">
					<picture>
						<source media="(min-width: 768px)" srcSet={imageUrl} />
						<img
							className="h-full lg:max-w-full w-full md:h-[unset] max-w-none lazyload"
							data-src={imageUrlMobile}
							alt=""
						/>
					</picture>
				</figure>

				<div className="absolute top-0 bottom-0 left-0 right-0 flex">
					<div className="flex flex-col m-auto md:ml-[12%]">
						<RichText
							tagName="span"
							placeholder="subtitle"
							className="cgsubtitle pl-4 text-xl italic font-normal text-center md:text-left text-cgWhite"
							value={cgsubtitle}
							onChange={(newSubtitle) =>
								setAttributes({ cgsubtitle: newSubtitle })
							}
						/>
						<RichText
							tagName="span"
							placeholder="Title"
							className="cgtitle text-6xl italic text-center md:text-left md:text-7xl text-cgWhite font-cinzel"
							value={cgtitle}
							onChange={(newTitle) => setAttributes({ cgtitle: newTitle })}
						/>
						<RichText
							tagName="span"
							placeholder="descripción"
							className="cgdescription pl-4 text-xl italic font-normal text-center md:text-left text-cgWhite"
							value={cgdescription}
							onChange={(newDescription) =>
								setAttributes({ cgdescription: newDescription })
							}
						/>
						<div className="flex flex-col my-6 md:justify-center md:flex-row md:items-center">
							<div>
								<GeneralButton description="Saber más" url={homeUrl} />
							</div>
							<div className="inner-blocks-container">
								{/* Allow only cg Button Block */}
								<InnerBlocks
									allowedBlocks={["cgblocks/button-block"]}
									template={[["cgblocks/button-block"]]}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Edit;
